export default __webpack_public_path__ + "static/media/DSC_0517.765bc80f.webp";